import store from '@appStore/store'
import { workspaceApi } from 'features/workspace'

import { confirmLinkedInLoginSession } from './api'
import type { LinkedInLoginResult } from './types'

async function applyLoginSuccessSideEffects(
	loginResult: LinkedInLoginResult,
	correlationId?: string | null
) {
	const headers = loginResult.headers
	if (!headers?.cookies?.length) {
		const result = false
		return result
	}

	try {
		await confirmLinkedInLoginSession(headers, correlationId)
	} catch {
		const result = false
		return result
	}

	const action = workspaceApi.endpoints.automationMode.initiate(undefined, {
		forceRefetch: true,
		subscribe: false
	})
	store.dispatch(action)

	const result = true
	return result
}

export { applyLoginSuccessSideEffects }
